<template>
  <v-container fluid>
    <v-row class="mb-4" align="center">
      <v-col>
        <h1 class="text-h5 font-weight-bold">Email Blast Templates</h1>
      </v-col>
      <v-col cols="auto">
        <v-btn color="primary" @click="$router.push('/email-blast/templates/new')">
          <v-icon left>mdi-plus</v-icon>
          New Template
        </v-btn>
      </v-col>
    </v-row>

    <v-card>
      <v-data-table
        :headers="headers"
        :items="templates"
        :loading="loading"
        loading-text="Loading templates..."
        no-data-text="No templates yet. Create your first one!"
      >
        <template #item.active="{ item }">
          <v-chip :color="item.active ? 'success' : 'grey'" small label text-color="white">
            {{ item.active ? 'Active' : 'Inactive' }}
          </v-chip>
        </template>

        <template #item.createdAt="{ item }">
          {{ formatDate(item.createdAt) }}
        </template>

        <template #item.actions="{ item }">
          <v-btn
            x-small
            outlined
            color="primary"
            class="mr-2"
            @click="$router.push(`/email-blast/templates/${item.id}/edit`)"
          >
            Edit
          </v-btn>
          <v-btn x-small outlined color="error" @click="confirmDelete(item)"> Delete </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title>Delete template?</v-card-title>
        <v-card-text>
          This action cannot be undone.
          <strong v-if="deleteTarget">{{ deleteTarget.name }}</strong> will be permanently removed.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="error" :loading="deleting" @click="handleDelete">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'EmailBlastTemplates',

  data() {
    return {
      templates: [],
      loading: false,
      deleteDialog: false,
      deleteTarget: null,
      deleting: false,
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Default Subject', value: 'subject' },
        { text: 'Status', value: 'active', sortable: false },
        { text: 'Created', value: 'createdAt' },
        { text: '', value: 'actions', sortable: false, align: 'end' },
      ],
    };
  },

  created() {
    this.fetchTemplates();
  },

  methods: {
    async fetchTemplates() {
      this.loading = true;
      try {
        const { data } = await axios.get('/v1/email-blast/templates');
        this.templates = data;
      } catch (err) {
        console.error('Failed to fetch templates', err);
      } finally {
        this.loading = false;
      }
    },

    confirmDelete(template) {
      this.deleteTarget = template;
      this.deleteDialog = true;
    },

    async handleDelete() {
      if (!this.deleteTarget) return;
      this.deleting = true;
      try {
        await axios.delete(`/v1/email-blast/templates/${this.deleteTarget.id}`);
        this.deleteDialog = false;
        this.deleteTarget = null;
        await this.fetchTemplates();
      } catch (err) {
        console.error('Failed to delete template', err);
      } finally {
        this.deleting = false;
      }
    },

    formatDate(dateStr) {
      if (!dateStr) return '';
      return new Date(dateStr).toLocaleDateString();
    },
  },
};
</script>
